import React from "react";
import Hero from "../hero/hero";
import Features from "../features/features";
import CTA from "../CTA/cta.jsx";

export default function Mainview() {
  return (
    <div id="wrapper">
      <Hero />
      <Features />
      <CTA />
    </div>
  );
}
